import React, { useEffect, useState } from "react";
import { fetchLessonStructure } from "../../../../../services/homeContentService";
import { Box, Heading, Flex, Input, Button, Textarea, useToast } from "@chakra-ui/react";
import { formatTextWithLineBreaks } from "../../../../../utils/formatText";
import Loader from "../../../../../components/common/Loader";
import { saveLessonStructure } from "../../../../../services/adminService";
import { useUser } from "@clerk/clerk-react";

const EditLessonStructure = () =>{
    const [structureList, setStructureList] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [editingIndex, setEditingIndex] = useState(null);
    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const toast = useToast();
    const {user} = useUser();

    useEffect(() =>{
        const getLessonStructure = async() =>{
            try{
                const response = await fetchLessonStructure();
                setStructureList(response || []);
                
            } catch(error){
                console.error('Error fetching lesson structure', error)
            } finally{
                setLoading(false);
            }
        }
        getLessonStructure();
    }, [])

    if(loading){
        return <Loader />;
    }

    const handleEditClick = (index, structure) =>{
        setIsEditing(true);
        setEditingIndex(index);
        setTitle(structure.title);
        setText(structure.text);
    }

    const handleSaveClick = async() =>{
        const updatedStructureList = [...structureList];
        updatedStructureList[editingIndex] = {...updatedStructureList[editingIndex], title, text};
        try{
            const response = await saveLessonStructure(updatedStructureList, user.id);
            if (response.ok){
                toast({
                    title: 'Lesson structure updated.',
                    description: 'Lesson structure updated successfully.',
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                })
            } else{
                toast({
                    title: 'Error',
                    description: 'Error while trying to update lesson structure.',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                })
            }
        } catch(error){
            console.error('error while trying to save lesson structure', error)
        }
 
        console.log(updatedStructureList)
        setStructureList(updatedStructureList)
        setIsEditing(false);
        setIsEditing(null);
    }

    const handleCancelClick = () =>{
        setIsEditing(false);
        setEditingIndex(null);
    }

    return(
        <Flex flexDirection="column" p={4} alignItems="center" border="1px solid #ccc" mb={4}>
            <Heading as='h3' mt={4} >Edit lessons structure</Heading>
            {structureList.map((structure, index) =>(
            <Box key={structure.id} textAlign="center" mb={4}>
                {isEditing && editingIndex === index ? (
                    <>
                        <Input
                            placeholder="Title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            mb={2}
                            dir="rtl"
                        />
                        <Textarea
                            placeholder="Text"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            mb={4}
                            dir="rtl"
                            height="15vh"
                            width="100%"
                        />
                        <Button onClick={handleSaveClick} colorScheme="green" mr={2}>
                            Save
                        </Button>
                        <Button onClick={handleCancelClick} colorScheme="red">
                            Cancel
                        </Button>
                    </>
                ):(
                    <>
                        <Box fontSize="xl" fontWeight="bold" mb={2}>
                            {structure.title}
                        </Box>
                        <Box dir="rtl">{formatTextWithLineBreaks(structure.text)}</Box>
                        <Button onClick={() => handleEditClick(index, structure)} colorScheme="blue" mt={2}>
                            Edit
                        </Button>
                    </>
                )}
            </Box>
            ))}
            
        </Flex>
    );
}

export default EditLessonStructure;